import React from "react";
import ListCompanyMissionVisionValue from "../../../containers/Settings/CompanyMissionVisionValue/index";
const SettingCompanyMissionVisionValue = () => {
  return <ListCompanyMissionVisionValue />;
};
export default SettingCompanyMissionVisionValue;
